import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import {
  closeInformationSidepanel,
  selectInformationSidepanel,
} from "../store/slices/informationSidepanelSlice";
import { useDispatch, useSelector } from "react-redux";

export default function InformationSidePanel() {
  const dispatch = useDispatch();
  const props = useSelector(selectInformationSidepanel);
  const sourceLink = props.sourceLink?.replace(/^\/+/, "");
  const handleClose = () => {
    dispatch(closeInformationSidepanel());
  };

  return (
    <Offcanvas
      show={props.id}
      onHide={handleClose}
      placement="end"
      className="information-sidepanel"
      backdropClassName="information-sidepanel-backdrop"
    >
      <Offcanvas.Header closeButton className="bg-colored-reverse text-white">
        <Offcanvas.Title>
          <div className=" fw-bold">
            Boomerang Help
            <div className="small text-white">#{props.id}</div>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="bg-page">
        <div dangerouslySetInnerHTML={{ __html: props.content }} />
        {sourceLink && (
          <div className="my-5">
            <a
              target="_blank"
              href={"https://help.uatboomcomms.com/docs/" + sourceLink}
            >
              Source
            </a>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}
